<template>
    <div  :style="{'height':clientHeight-90+'px'}">
        <!--        <div class="card-header">-->
        <!--            <h5>回访一周数据</h5>-->
        <!--        </div>-->
        <vue-scroll :ops="$ops">
            <div >
                <div class="m-portlet mb-10">
                    <div class="m-portlet__body">
                        <el-form label-position="left">
                            <el-row :gutter="20">
                                <el-col :span="10">
                                    <el-form-item label="筛选日期">
                                        <el-date-picker
                                                v-model="clickDate"
                                                type="date"
                                                placeholder="选择日期"
                                                value-format="yyyy-MM-dd"
                                                :picker-options="pickerOptions1"
                                                @change="changeDate()">
                                        </el-date-picker>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                    </div>
                </div>
                <div class="m-portlet m-b-0">
                    <div class="m-portlet__body" v-loading="loading">
                        <el-table
                                :data="orderHeadTeachers"
                                style="width: 100%"
                                size="middle">
                            <el-table-column prop="name" label="班主任"></el-table-column>
                            <el-table-column prop="headTeacher_students_renewalRate">
                                <template slot="header" slot-scope="scope">
                                    周一<br> {{days[0]}}
                                </template>
                                <template slot-scope="scope">
                                    <el-popover
                                            placement="right"
                                            width="300"
                                            trigger="hover">
                                        <div v-for="(one,index) in scope.row.headTeacher_week_content[0].student_content"
                                             :key="index">
                                            <div style="margin-top: 5px">
                                                <el-row>
                                                    <el-col :span="6" style="margin-top: 5px"> {{one.student_name}}
                                                    </el-col>
                                                    <el-col :span="10" style="margin-top: 5px">
                                                        <el-tag type="danger" >{{one.date_record[0]}}</el-tag>
                                                        <el-tag type="success">{{one.date_record[1]}}</el-tag>
                                                        <el-tag type="primary">{{one.date_record[2]}}</el-tag>
                                                        <el-tag type="warning">{{one.date_record[3]}}</el-tag>
                                                    </el-col>
                                                    <el-col :span="8">
                                                        <el-button
                                                                @click="handleReturnVisitInformation(one.student_id,one.student_name)">
                                                            回访详情
                                                        </el-button>
                                                    </el-col>
                                                </el-row>
                                            </div>
                                        </div>
                                        <el-button slot="reference"
                                                   :disabled="scope.row.headTeacher_week_content[0].number==0">
                                            共{{scope.row.headTeacher_week_content[0].number}}人<br>
                                            反馈：{{scope.row.headTeacher_week_content[0].date_return_record[0]}}建议：{{scope.row.headTeacher_week_content[0].date_return_record[1]}}<br>
                                            卖课：{{scope.row.headTeacher_week_content[0].date_return_record[2]}}其他：{{scope.row.headTeacher_week_content[0].date_return_record[3]}}
                                        </el-button>
                                    </el-popover>
                                </template>
                            </el-table-column>
                            <el-table-column prop="headTeacher_students_renewalRate">
                                <template slot="header" slot-scope="scope">
                                    周二<br> {{days[1]}}
                                </template>
                                <template slot-scope="scope">
                                    <el-popover
                                            placement="right"
                                            width="300"
                                            trigger="hover">
                                        <div v-for="(one,index) in scope.row.headTeacher_week_content[1].student_content"
                                             :key="index">
                                            <div style="margin-top: 5px">
                                                <el-row>
                                                    <el-col :span="6" style="margin-top: 5px"> {{one.student_name}}
                                                    </el-col>
                                                    <el-col :span="10" style="margin-top: 5px">
                                                        <el-tag type="danger">{{one.date_record[0]}}</el-tag>
                                                        <el-tag type="success">{{one.date_record[1]}}</el-tag>
                                                        <el-tag type="primary">{{one.date_record[2]}}</el-tag>
                                                        <el-tag type="warning">{{one.date_record[3]}}</el-tag>
                                                    </el-col>
                                                    <el-col :span="8">
                                                        <el-button
                                                                @click="handleReturnVisitInformation(one.student_id,one.student_name)">
                                                            回访详情
                                                        </el-button>
                                                    </el-col>
                                                </el-row>
                                            </div>
                                        </div>
                                        <el-button slot="reference"
                                                   :disabled="scope.row.headTeacher_week_content[1].number==0">
                                            共{{scope.row.headTeacher_week_content[1].number}}人<br>
                                            反馈：{{scope.row.headTeacher_week_content[1].date_return_record[0]}}建议：{{scope.row.headTeacher_week_content[1].date_return_record[1]}}<br>
                                            卖课：{{scope.row.headTeacher_week_content[1].date_return_record[2]}}其他：{{scope.row.headTeacher_week_content[1].date_return_record[3]}}
                                        </el-button>
                                    </el-popover>
                                </template>
                            </el-table-column>
                            <el-table-column prop="headTeacher_students_renewalRate">
                                <template slot="header" slot-scope="scope">
                                    周三<br> {{days[2]}}
                                </template>
                                <template slot-scope="scope">
                                    <el-popover
                                            placement="right"
                                            width="300"
                                            trigger="hover">
                                        <div v-for="(one,index) in scope.row.headTeacher_week_content[2].student_content"
                                             :key="index">
                                            <div style="margin-top: 5px">
                                                <el-row>
                                                    <el-col :span="6" style="margin-top: 5px"> {{one.student_name}}
                                                    </el-col>
                                                    <el-col :span="10" style="margin-top: 5px">
                                                        <el-tag type="danger">{{one.date_record[0]}}</el-tag>
                                                        <el-tag type="success">{{one.date_record[1]}}</el-tag>
                                                        <el-tag type="primary">{{one.date_record[2]}}</el-tag>
                                                        <el-tag type="warning">{{one.date_record[3]}}</el-tag>
                                                    </el-col>
                                                    <el-col :span="8">
                                                        <el-button
                                                                @click="handleReturnVisitInformation(one.student_id,one.student_name)">
                                                            回访详情
                                                        </el-button>
                                                    </el-col>
                                                </el-row>
                                            </div>
                                        </div>
                                        <el-button slot="reference"
                                                   :disabled="scope.row.headTeacher_week_content[2].number==0">
                                            共{{scope.row.headTeacher_week_content[2].number}}人<br>
                                            反馈：{{scope.row.headTeacher_week_content[2].date_return_record[0]}}建议：{{scope.row.headTeacher_week_content[2].date_return_record[1]}}<br>
                                            卖课：{{scope.row.headTeacher_week_content[2].date_return_record[2]}}其他：{{scope.row.headTeacher_week_content[2].date_return_record[3]}}
                                        </el-button>
                                    </el-popover>
                                </template>
                            </el-table-column>
                            <el-table-column prop="headTeacher_students_renewalRate">
                                <template slot="header" slot-scope="scope">
                                    周四<br> {{days[3]}}
                                </template>
                                <template slot-scope="scope">
                                    <el-popover
                                            placement="right"
                                            width="300"
                                            trigger="hover">
                                        <div v-for="(one,index) in scope.row.headTeacher_week_content[3].student_content"
                                             :key="index">
                                            <div style="margin-top: 5px">
                                                <el-row>
                                                    <el-col :span="6" style="margin-top: 5px"> {{one.student_name}}
                                                    </el-col>
                                                    <el-col :span="10" style="margin-top: 5px">
                                                        <el-tag type="danger">{{one.date_record[0]}}</el-tag>
                                                        <el-tag type="success">{{one.date_record[1]}}</el-tag>
                                                        <el-tag type="primary">{{one.date_record[2]}}</el-tag>
                                                        <el-tag type="warning">{{one.date_record[3]}}</el-tag>
                                                    </el-col>
                                                    <el-col :span="8">
                                                        <el-button
                                                                @click="handleReturnVisitInformation(one.student_id,one.student_name)">
                                                            回访详情
                                                        </el-button>
                                                    </el-col>
                                                </el-row>
                                            </div>
                                        </div>
                                        <el-button slot="reference"
                                                   :disabled="scope.row.headTeacher_week_content[3].number==0">
                                            共{{scope.row.headTeacher_week_content[3].number}}人<br>
                                            反馈：{{scope.row.headTeacher_week_content[3].date_return_record[0]}}建议：{{scope.row.headTeacher_week_content[3].date_return_record[1]}}<br>
                                            卖课：{{scope.row.headTeacher_week_content[3].date_return_record[2]}}其他：{{scope.row.headTeacher_week_content[3].date_return_record[3]}}
                                        </el-button>
                                    </el-popover>
                                </template>
                            </el-table-column>
                            <el-table-column prop="headTeacher_students_renewalRate">
                                <template slot="header" slot-scope="scope">
                                    周五<br> {{days[4]}}
                                </template>
                                <template slot-scope="scope">
                                    <el-popover
                                            placement="right"
                                            width="300"
                                            trigger="hover">
                                        <div v-for="(one,index) in scope.row.headTeacher_week_content[4].student_content"
                                             :key="index">
                                            <div style="margin-top: 5px">
                                                <el-row>
                                                    <el-col :span="6" style="margin-top: 5px"> {{one.student_name}}
                                                    </el-col>
                                                    <el-col :span="10" style="margin-top: 5px">
                                                        <el-tag type="danger">{{one.date_record[0]}}</el-tag>
                                                        <el-tag type="success">{{one.date_record[1]}}</el-tag>
                                                        <el-tag type="primary">{{one.date_record[2]}}</el-tag>
                                                        <el-tag type="warning">{{one.date_record[3]}}</el-tag>
                                                    </el-col>
                                                    <el-col :span="8">
                                                        <el-button
                                                                @click="handleReturnVisitInformation(one.student_id,one.student_name)">
                                                            回访详情
                                                        </el-button>
                                                    </el-col>
                                                </el-row>
                                            </div>
                                        </div>
                                        <el-button slot="reference"
                                                   :disabled="scope.row.headTeacher_week_content[4].number==0">
                                            共{{scope.row.headTeacher_week_content[4].number}}人<br>
                                            反馈：{{scope.row.headTeacher_week_content[4].date_return_record[0]}}建议：{{scope.row.headTeacher_week_content[4].date_return_record[1]}}<br>
                                            卖课：{{scope.row.headTeacher_week_content[4].date_return_record[2]}}其他：{{scope.row.headTeacher_week_content[4].date_return_record[3]}}
                                        </el-button>
                                    </el-popover>
                                </template>
                            </el-table-column>
                            <el-table-column prop="headTeacher_students_renewalRate">
                                <template slot="header" slot-scope="scope">
                                    周六<br> {{days[5]}}
                                </template>
                                <template slot-scope="scope">
                                    <el-popover
                                            placement="right"
                                            width="300"
                                            trigger="hover">
                                        <div v-for="(one,index) in scope.row.headTeacher_week_content[5].student_content"
                                             :key="index">
                                            <div style="margin-top: 5px">
                                                <el-row>
                                                    <el-col :span="6" style="margin-top: 5px"> {{one.student_name}}
                                                    </el-col>
                                                    <el-col :span="10" style="margin-top: 5px">
                                                        <el-tag type="danger">{{one.date_record[0]}}</el-tag>
                                                        <el-tag type="success">{{one.date_record[1]}}</el-tag>
                                                        <el-tag type="primary">{{one.date_record[2]}}</el-tag>
                                                        <el-tag type="warning">{{one.date_record[3]}}</el-tag>
                                                    </el-col>
                                                    <el-col :span="8">
                                                        <el-button
                                                                @click="handleReturnVisitInformation(one.student_id,one.student_name)">
                                                            回访详情
                                                        </el-button>
                                                    </el-col>
                                                </el-row>
                                            </div>
                                        </div>
                                        <el-button slot="reference"
                                                   :disabled="scope.row.headTeacher_week_content[5].number==0">
                                            共{{scope.row.headTeacher_week_content[5].number}}人<br>
                                            反馈：{{scope.row.headTeacher_week_content[5].date_return_record[0]}}建议：{{scope.row.headTeacher_week_content[5].date_return_record[1]}}<br>
                                            卖课：{{scope.row.headTeacher_week_content[5].date_return_record[2]}}其他：{{scope.row.headTeacher_week_content[5].date_return_record[3]}}
                                        </el-button>
                                    </el-popover>
                                </template>
                            </el-table-column>
                            <el-table-column prop="headTeacher_students_renewalRate">
                                <template slot="header" slot-scope="scope">
                                    周日<br> {{days[6]}}
                                </template>
                                <template slot-scope="scope">
                                    <el-popover
                                            placement="right"
                                            width="300"
                                            trigger="hover">
                                        <div v-for="(one,index) in scope.row.headTeacher_week_content[6].student_content"
                                             :key="index">
                                            <div style="margin-top: 5px">
                                                <el-row>
                                                    <el-col :span="6" style="margin-top: 5px"> {{one.student_name}}</el-col>
                                                    <el-col :span="10" style="margin-top: 5px">
                                                        <el-tag type="danger">{{one.date_record[0]}}</el-tag>
                                                        <el-tag type="success">{{one.date_record[1]}}</el-tag>
                                                        <el-tag type="primary">{{one.date_record[2]}}</el-tag>
                                                        <el-tag type="warning">{{one.date_record[3]}}</el-tag>
                                                    </el-col>
                                                    <el-col :span="8">
                                                        <el-button
                                                                @click="handleReturnVisitInformation(one.student_id,one.student_name)">
                                                            回访详情
                                                        </el-button>
                                                    </el-col>
                                                </el-row>
                                            </div>
                                        </div>
                                        <el-button slot="reference"
                                                   :disabled="scope.row.headTeacher_week_content[6].number==0">
                                            共{{scope.row.headTeacher_week_content[6].number}}人<br>
                                            反馈：{{scope.row.headTeacher_week_content[6].date_return_record[0]}}建议：{{scope.row.headTeacher_week_content[6].date_return_record[1]}}<br>
                                            卖课：{{scope.row.headTeacher_week_content[6].date_return_record[2]}}其他：{{scope.row.headTeacher_week_content[6].date_return_record[3]}}
                                        </el-button>
                                    </el-popover>
                                </template>
                            </el-table-column>
                            <el-table-column prop="headTeacher_students_renewalRate">
                                <template slot="header">
                                    周总计
                                </template>
                                <template slot-scope="scope">
                                    <el-popover
                                            placement="right"
                                            width="300"
                                            trigger="hover">
                                        <div v-for="(one,index) in scope.row.week_sum_student" :key="index">
                                            <div style="margin-top: 5px">
                                                <el-row>
                                                    <el-col :span="6" style="margin-top: 5px"> {{one.student_name}}
                                                    </el-col>
                                                    <el-col :span="10" style="margin-top: 5px">
                                                        <el-tag type="danger">{{one.week_record[0]}}</el-tag>
                                                        <el-tag type="success">{{one.week_record[1]}}</el-tag>
                                                        <el-tag type="primary">{{one.week_record[2]}}</el-tag>
                                                        <el-tag type="warning">{{one.week_record[3]}}</el-tag>
                                                    </el-col>
                                                    <el-col :span="8">
                                                        <el-button
                                                                @click="handleReturnVisitInformation(one.student_id,one.student_name)">
                                                            回访详情
                                                        </el-button>
                                                    </el-col>
                                                </el-row>
                                            </div>
                                        </div>
                                        <el-button slot="reference"
                                                   :disabled="scope.row.sum_week_headTeacher_student_number==0">
                                            共{{scope.row.sum_week_headTeacher_student_number}}人<br>
                                            反馈：{{scope.row.week_return_record[0]}}建议：{{scope.row.week_return_record[1]}}<br>
                                            卖课：{{scope.row.week_return_record[2]}}其他：{{scope.row.week_return_record[3]}}
                                        </el-button>
                                    </el-popover>
                                </template>
                            </el-table-column>
                            <el-table-column prop="headTeacher_students_renewalRate">
                                <template slot="header">
                                    月总计
                                </template>
                                <template slot-scope="scope">
                                    <el-button slot="reference" disabled>
                                            共{{scope.row.month_sum_student}}人<br>
                                            反馈：{{scope.row.month_return_record[0]}}建议：{{scope.row.month_return_record[1]}}<br>
                                            卖课：{{scope.row.month_return_record[2]}}其他：{{scope.row.month_return_record[3]}}
                                    </el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <!--分页-->
                        <div class="text-center m-t-10">
                            <el-pagination
                                    @size-change="handleSizeChange"
                                    @current-change="handleCurrentChange"
                                    :current-page="currentPage"
                                    :page-sizes="[10, 20, 50, 100]"
                                    :page-size="10"
                                    layout="total, sizes, prev, pager, next, jumper"
                                    :total="total">
                            </el-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </vue-scroll>
    </div>
</template>

<script>

    export default {
        name: "Index",
        data() {
            return {
                path: "/returnWeek/list",
                pickerOptions1: {
                    disabledDate(time) {
                        return time.getTime() > Date.now();
                    },
                    shortcuts: [{
                        text: '今天',
                        onClick(picker) {
                            picker.$emit('pick', new Date());
                        }
                    }, {
                        text: '昨天',
                        onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() - 3600 * 1000 * 24);
                            picker.$emit('pick', date);
                        }
                    }, {
                        text: '一周前',
                        onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', date);
                        }
                    }]
                },
                loading: true,
                semesters: [],
                weeks: [],
                headTeachers: [],
                days: [],
                semester_id: '',
                week: '',
                headTeacher: '',
                oneDate: '',
                clickDate: '',
                isShow: false,
                total: 0,
                currentPage: 1,
                currentPageSize: 10,
            }
        },
        created() {
            this.handleCreate();
            this.handleIndex();
        },
        mounted() {
            this.$nextTick(() => {
            })
        },
        computed: {
            orderHeadTeachers: function () {
                return this._.values(this.headTeachers);
            },
            clientHeight() {
                return this.$store.state.config.clientHeight
            },
        },
        methods: {
            handleShowStudent(id, date) {
                this.isShow = !this.isShow;
                this.headTeacher = id;
                this.oneDate = date;
            },
            changeSemester() {
                this.loading = true;
                this.handleCreate();
            },
            changeWeek() {
                this.loading = true;
                this.handleIndex();
            },
            changeDate() {
                this.loading = true;
                this.handleIndex();
            },
            handleCreate() {
                //建立webSocket链接
                this.$wApi.addListen(this.path, this.handleData);
                this.$wApi.send(this.path, 'init', {
                    'semester_id': 3,
                    'section_id': 1,
                });
            },
            handleData(event, data) {
                switch (event) {
                    case 'init':
                        this.semesters = data.semesters;
                        this.weeks = data.weeks;
                        this.loading = false;
                        break;
                    case 'list':
                        this.total = data.total;
                        this.headTeachers = data.headTeachers;
                        this.days = data.days;
                        this.loading = false;
                        break;
                }
            },
            handleIndex(currentPage = 1) {
                if (currentPage === 1) {
                    this.currentPage = 1
                }
                this.$wApi.send(this.path, 'list', {
                    'currentPage': this.currentPage,
                    'currentPageSize': this.currentPageSize,
                    'week': this.week,
                    'date': this.clickDate,
                });
            },
            handleReturnVisitInformation(student_id, title) {
                this.$store.dispatch('addView', {
                    'title': '回访' + title,
                    'path': '/returnVisitDetail/' + student_id,
                    'closable': true
                });
                this.router.push({path: '/returnVisitDetail/' + student_id})
            },
            handleSizeChange(val) {
                this.currentPageSize = val;
                this.loading = true;
                this.handleIndex(this.currentPage, this.currentPageSize)
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.loading = true;
                this.handleIndex(this.currentPage, this.currentPageSize)
            },

        }
    }
</script>

<style scoped>

</style>
